// GESTÃO DE Estoque DE MANUTENÇÂO

import axios from "axios";

const SPARE_RESERVE_ROOT = "https://api.darwinx.com.br";
const SPARE_API_BASE_URL = SPARE_RESERVE_ROOT + "/sparesreserve";

class SpareReserveService {
  getSparesReserve(spare) {
    return axios.get(SPARE_API_BASE_URL, { params: spare });
  }

  createSpareReserve(spare) {
    return axios.post(SPARE_API_BASE_URL, spare);
  }

  getSpareReserveById(spareId) {
    return axios.get(SPARE_API_BASE_URL + "/" + spareId);
  }

  updateSpareReserve(spare, spareId) {
    return axios.put(SPARE_API_BASE_URL + "/" + spareId, spare);
  }

  deleteSpareReserve(spareId) {
    return axios.delete(SPARE_API_BASE_URL + "/" + spareId);
  }

  // --- Ações transacionais (a contabilização de estoque é feita no backend) ---
  // Remove a reserva e devolve o estoque reservado (atômico no servidor).
  removeReserve(spareReserveId) {
    return axios.delete(SPARE_API_BASE_URL + "/" + spareReserveId);
  }

  // +1 unidade (valida disponibilidade no servidor; 409 se não houver).
  incrementReserve(spareReserveId) {
    return axios.get(
      SPARE_RESERVE_ROOT + "/spares-reserve/cart/increment/" + spareReserveId
    );
  }

  // -1 unidade (remove a reserva se chegar a 0; retorna { removed, reserve }).
  decrementReserve(spareReserveId) {
    return axios.get(
      SPARE_RESERVE_ROOT + "/spares-reserve/cart/decrement/" + spareReserveId
    );
  }

  // Entrega: baixa física única do estoque.
  deliver(spareReserveId, responsavel) {
    return axios.put(SPARE_API_BASE_URL + "/" + spareReserveId + "/deliver", {
      responsavel,
    });
  }

  // Estorno de entrega: restaura quantidade física E itens_reservados.
  undoDeliver(spareReserveId, responsavel) {
    return axios.put(
      SPARE_API_BASE_URL + "/" + spareReserveId + "/undo-deliver",
      { responsavel }
    );
  }
}

export default new SpareReserveService();
